<template>
  <section class="mx-auto flex h-fit w-full max-w-container flex-col">
    <slot />
  </section>
</template>
